import {
  FulfillmentGroupTagSource,
  TagKind,
} from "@redotech/redo-common-model-tags-common/tag";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { Flex } from "@redotech/redo-web/flex";
import { PillTheme } from "@redotech/redo-web/pill";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { TagList } from "../../common/tag-list";
import { getExpandedItems } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries.productTags;

function getTags(row: FulfillmentGroupData) {
  const allTags = new Set<string>();

  // Gather all product tags from line items
  if (row.items) {
    for (const item of row.items) {
      if (item.productTags) {
        for (const tag of item.productTags) {
          allTags.add(tag);
        }
      }
    }
  }

  return Array.from(allTags).map((tag) => ({
    name: tag,
    pillTheme: PillTheme.NORMAL,
    source: FulfillmentGroupTagSource.MERCHANT,
    kind: TagKind.FULFILLMENT_GROUP,
  }));
}

export const ProductTagsColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => {
    const renderedTags = getTags(row);
    return (
      <Flex pl="lg">
        <TagList compactFallback hoverToShow tags={renderedTags} />
      </Flex>
    );
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => {
    const productTags =
      getExpandedItems(row)?.[expansionIndex]?.productTags ?? [];
    const renderedTags = productTags.map((tag) => ({
      name: tag,
      pillTheme: PillTheme.NORMAL,
      source: FulfillmentGroupTagSource.MERCHANT,
      kind: TagKind.FULFILLMENT_GROUP,
    }));

    return (
      <Flex pl="lg">
        <TagList compactFallback hoverToShow tags={renderedTags} />
      </Flex>
    );
  },
};
